import React from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import { BulkActionWrapper } from './BulkActionWrapper';

interface BulkActionIconButtonProps {
    pageName: string;
    actionLabel: string;
    onConfirm: (processAll: boolean, selectedIds: any[]) => void;
    icon: React.ReactNode;
    tooltip?: string;
    isPending?: boolean;
    disabled?: boolean;
    color?: "default" | "inherit" | "primary" | "secondary";
    size?: "small" | "medium";
    customText?: string;
    title?: string;
}

export const BulkActionIconButton = ({
    pageName,
    actionLabel,
    onConfirm,
    icon,
    tooltip,
    isPending,
    disabled,
    color = "primary",
    size = "small",
    customText,
    title
}: BulkActionIconButtonProps) => {
    return (
        <BulkActionWrapper
            pageName={pageName}
            actionLabel={actionLabel}
            onConfirm={onConfirm}
            title={title}
            customText={customText}
            isPending={isPending}
        >
            {(onClick) => (
                <Tooltip title={tooltip || actionLabel}>
                    <span>
                        <IconButton
                            aria-label={actionLabel.toLowerCase()}
                            size={size}
                            onClick={onClick}
                            disabled={disabled || isPending}
                            color={color}
                        >
                            {isPending ? <CircularProgress size={16} color="inherit" /> : icon}
                        </IconButton>
                    </span>
                </Tooltip>
            )}
        </BulkActionWrapper>
    );
};
